module.exports = {
  RETRIEVE_LEFT_OPERATORS_WITH_IMPCS_BY_ROLE_REQUEST: 'RETRIEVE_LEFT_OPERATORS_WITH_IMPCS_BY_ROLE_REQUEST',
  RETRIEVE_LEFT_OPERATORS_WITH_IMPCS_BY_ROLE_SUCCESS: 'RETRIEVE_LEFT_OPERATORS_WITH_IMPCS_BY_ROLE_SUCCESS',
  RETRIEVE_LEFT_OPERATORS_WITH_IMPCS_BY_ROLE_FAILURE: 'RETRIEVE_LEFT_OPERATORS_WITH_IMPCS_BY_ROLE_FAILURE',

  RETRIEVE_RIGHT_OPERATORS_WITH_IMPCS_BY_ROLE_REQUEST: 'RETRIEVE_RIGHT_OPERATORS_WITH_IMPCS_BY_ROLE_REQUEST',
  RETRIEVE_RIGHT_OPERATORS_WITH_IMPCS_BY_ROLE_SUCCESS: 'RETRIEVE_RIGHT_OPERATORS_WITH_IMPCS_BY_ROLE_SUCCESS',
  RETRIEVE_RIGHT_OPERATORS_WITH_IMPCS_BY_ROLE_FAILURE: 'RETRIEVE_RIGHT_OPERATORS_WITH_IMPCS_BY_ROLE_FAILURE',

  RETRIEVE_ALL_LEFT_OPERATORS_WITH_IMPCS_REQUEST: 'RETRIEVE_ALL_LEFT_OPERATORS_WITH_IMPCS_REQUEST',
  RETRIEVE_ALL_LEFT_OPERATORS_WITH_IMPCS_SUCCESS: 'RETRIEVE_ALL_LEFT_OPERATORS_WITH_IMPCS_SUCCESS',
  RETRIEVE_ALL_LEFT_OPERATORS_WITH_IMPCS_FAILURE: 'RETRIEVE_ALL_LEFT_OPERATORS_WITH_IMPCS_FAILURE',

  RETRIEVE_ALL_RIGHT_OPERATORS_WITH_IMPCS_REQUEST: 'RETRIEVE_ALL_RIGHT_OPERATORS_WITH_IMPCS_REQUEST',
  RETRIEVE_ALL_RIGHT_OPERATORS_WITH_IMPCS_SUCCESS: 'RETRIEVE_ALL_RIGHT_OPERATORS_WITH_IMPCS_SUCCESS',
  RETRIEVE_ALL_RIGHT_OPERATORS_WITH_IMPCS_FAILURE: 'RETRIEVE_ALL_RIGHT_OPERATORS_WITH_IMPCS_FAILURE',

  RETRIEVE_LEFT_ASSET_TYPE_OPERATORS_WITH_IMPCS_REQUEST: 'RETRIEVE_LEFT_ASSET_TYPE_OPERATORS_WITH_IMPCS_REQUEST',
  RETRIEVE_LEFT_ASSET_TYPE_OPERATORS_WITH_IMPCS_SUCCESS: 'RETRIEVE_LEFT_ASSET_TYPE_OPERATORS_WITH_IMPCS_SUCCESS',
  RETRIEVE_LEFT_ASSET_TYPE_OPERATORS_WITH_IMPCS_FAILURE: 'RETRIEVE_LEFT_ASSET_TYPE_OPERATORS_WITH_IMPCS_FAILURE',

  RETRIEVE_RIGHT_ASSET_TYPE_OPERATORS_WITH_IMPCS_REQUEST: 'RETRIEVE_RIGHT_ASSET_TYPE_OPERATORS_WITH_IMPCS_REQUEST',
  RETRIEVE_RIGHT_ASSET_TYPE_OPERATORS_WITH_IMPCS_SUCCESS: 'RETRIEVE_RIGHT_ASSET_TYPE_OPERATORS_WITH_IMPCS_SUCCESS',
  RETRIEVE_RIGHT_ASSET_TYPE_OPERATORS_WITH_IMPCS_FAILURE: 'RETRIEVE_RIGHT_ASSET_TYPE_OPERATORS_WITH_IMPCS_FAILURE',

  RETRIEVE_LEFT_OPERATORS_BY_ROLE_REQUEST: 'RETRIEVE_LEFT_OPERATORS_BY_ROLE_REQUEST',
  RETRIEVE_LEFT_OPERATORS_BY_ROLE_SUCCESS: 'RETRIEVE_LEFT_OPERATORS_BY_ROLE_SUCCESS',
  RETRIEVE_LEFT_OPERATORS_BY_ROLE_FAILURE: 'RETRIEVE_LEFT_OPERATORS_BY_ROLE_FAILURE',

  RETRIEVE_RIGHT_OPERATORS_BY_ROLE_REQUEST: 'RETRIEVE_RIGHT_OPERATORS_BY_ROLE_REQUEST',
  RETRIEVE_RIGHT_OPERATORS_BY_ROLE_SUCCESS: 'RETRIEVE_RIGHT_OPERATORS_BY_ROLE_SUCCESS',
  RETRIEVE_RIGHT_OPERATORS_BY_ROLE_FAILURE: 'RETRIEVE_RIGHT_OPERATORS_BY_ROLE_FAILURE',

  RETRIEVE_ALL_LEFT_OPERATORS_REQUEST: 'RETRIEVE_ALL_LEFT_OPERATORS_REQUEST',
  RETRIEVE_ALL_LEFT_OPERATORS_SUCCESS: 'RETRIEVE_ALL_LEFT_OPERATORS_SUCCESS',
  RETRIEVE_ALL_LEFT_OPERATORS_FAILURE: 'RETRIEVE_ALL_LEFT_OPERATORS_FAILURE',

  RETRIEVE_ALL_RIGHT_OPERATORS_REQUEST: 'RETRIEVE_ALL_RIGHT_OPERATORS_REQUEST',
  RETRIEVE_ALL_RIGHT_OPERATORS_SUCCESS: 'RETRIEVE_ALL_RIGHT_OPERATORS_SUCCESS',
  RETRIEVE_ALL_RIGHT_OPERATORS_FAILURE: 'RETRIEVE_ALL_RIGHT_OPERATORS_FAILURE',

  RETRIEVE_LEFT_GLOBAL_IMPC_PRESET_REQUEST: 'RETRIEVE_LEFT_GLOBAL_IMPC_PRESET_REQUEST',
  RETRIEVE_LEFT_GLOBAL_IMPC_PRESET_SUCCESS: 'RETRIEVE_LEFT_GLOBAL_IMPC_PRESET_SUCCESS',
  RETRIEVE_LEFT_GLOBAL_IMPC_PRESET_FAILURE: 'RETRIEVE_LEFT_GLOBAL_IMPC_PRESET_FAILURE',

  RETRIEVE_RIGHT_GLOBAL_IMPC_PRESET_REQUEST: 'RETRIEVE_RIGHT_GLOBAL_IMPC_PRESET_REQUEST',
  RETRIEVE_RIGHT_GLOBAL_IMPC_PRESET_SUCCESS: 'RETRIEVE_RIGHT_GLOBAL_IMPC_PRESET_SUCCESS',
  RETRIEVE_RIGHT_GLOBAL_IMPC_PRESET_FAILURE: 'RETRIEVE_RIGHT_GLOBAL_IMPC_PRESET_FAILURE',

  RETRIEVE_LEFT_GLOBAL_OPERATOR_PRESET_REQUEST: 'RETRIEVE_LEFT_GLOBAL_OPERATOR_PRESET_REQUEST',
  RETRIEVE_LEFT_GLOBAL_OPERATOR_PRESET_SUCCESS: 'RETRIEVE_LEFT_GLOBAL_OPERATOR_PRESET_SUCCESS',
  RETRIEVE_LEFT_GLOBAL_OPERATOR_PRESET_FAILURE: 'RETRIEVE_LEFT_GLOBAL_OPERATOR_PRESET_FAILURE',

  RETRIEVE_RIGHT_GLOBAL_OPERATOR_PRESET_REQUEST: 'RETRIEVE_RIGHT_GLOBAL_OPERATOR_PRESET_REQUEST',
  RETRIEVE_RIGHT_GLOBAL_OPERATOR_PRESET_SUCCESS: 'RETRIEVE_RIGHT_GLOBAL_OPERATOR_PRESET_SUCCESS',
  RETRIEVE_RIGHT_GLOBAL_OPERATOR_PRESET_FAILURE: 'RETRIEVE_RIGHT_GLOBAL_OPERATOR_PRESET_FAILURE',

  LEFT_POSTAL_OPERATOR_EXPANDED: 'LEFT_POSTAL_OPERATOR_EXPANDED',
  LEFT_POSTAL_OPERATOR_CHECKED: 'LEFT_POSTAL_OPERATOR_CHECKED',
  LEFT_MAIL_PROCESSING_CENTER_CHECKED: 'LEFT_MAIL_PROCESSING_CENTER_CHECKED',
  SELECT_ALL_LEFT_POSTAL_OPERATORS: 'SELECT_ALL_LEFT_POSTAL_OPERATORS',
  SELECT_ALL_LEFT_MAIL_PROCESSING_CENTERS: 'SELECT_ALL_LEFT_MAIL_PROCESSING_CENTERS',
  UNSELECT_ALL_LEFT_POSTAL_OPERATORS: 'UNSELECT_ALL_LEFT_POSTAL_OPERATORS',
  UNSELECT_ALL_LEFT_MAIL_PROCESSING_CENTERS: 'UNSELECT_ALL_LEFT_MAIL_PROCESSING_CENTERS',

  RIGHT_POSTAL_OPERATOR_EXPANDED: 'RIGHT_POSTAL_OPERATOR_EXPANDED',
  RIGHT_POSTAL_OPERATOR_CHECKED: 'RIGHT_POSTAL_OPERATOR_CHECKED',
  RIGHT_MAIL_PROCESSING_CENTER_CHECKED: 'RIGHT_MAIL_PROCESSING_CENTER_CHECKED',
  SELECT_ALL_RIGHT_POSTAL_OPERATORS: 'SELECT_ALL_RIGHT_POSTAL_OPERATORS',
  SELECT_ALL_RIGHT_MAIL_PROCESSING_CENTERS: 'SELECT_ALL_RIGHT_MAIL_PROCESSING_CENTERS',
  UNSELECT_ALL_RIGHT_POSTAL_OPERATORS: 'UNSELECT_ALL_RIGHT_POSTAL_OPERATORS',
  UNSELECT_ALL_RIGHT_MAIL_PROCESSING_CENTERS: 'UNSELECT_ALL_RIGHT_MAIL_PROCESSING_CENTERS',

  SET_SELECTED_OPERATOR_IMPC_ON_TABLE: 'SET_SELECTED_OPERATOR_IMPC_ON_TABLE',
  SWAP_TREES: 'SWAP_TREES',
};
